<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="fci">Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Inicio"
                      v-model="$v.filtro.fechaInicio.$model"
                      :state="validateState('fechaInicio')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label for="fcf">Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                      name="nombre"
                      placeholder="Fecha de Fin"
                      :min="filtro.fechaInicio"
                      v-model="$v.filtro.fechaFin.$model"
                      :state="validateState('fechaFin')"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                  variant="outline-primary"
                  :disabled="loader"
                  @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col cols="12">
          <download-excel
              v-if="datosTabla.length > 0"
              class="btn btn-primary"
              :data="datosTabla"
              :fields="fieldsExcel"
              worksheet="IngresosClinicas"
              name="reporte de comisiones BIP.xls"
          >
            Generar Excel
            <em class="fa fa-file-excel-o"></em>
          </download-excel>
        </b-col>
        <b-col cols="12">
          <div v-if="!loader" class="overflow-auto">
            <b-row>
              <b-col>
                <b-form-input v-if="datosTabla.length > 0" placeholder="Filtrar" v-model="palabraClave"></b-form-input>
              </b-col>
            </b-row>
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTabla"
                :fields="fields"
                :filter="palabraClave"
                :filter-function="filterTable"
                striped
                responsive="true"
                foot-clone
                no-footer-sorting
                foot-row-variant="secondary"
                class="parrafos"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
            >
              <template v-slot:cell(bono)="row">
                {{row.item.bono | moneda}}
              </template>
              <template #foot()="row">
                {{ " " }}
              </template>
              <template #foot(empleado)="row">
                <div class="text-right">
                  Total:
                </div>

              </template>
              <template #foot(bono)="row">
                {{subTotal | moneda}}
              </template>
            </b-table>
          </div>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  name: "ReporteComisionesGeneral",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      registrosPorPagina: 300,
      paginaActual: 1,
      loader: false,
      datosTabla: [],
      fields: [
        {key: "idComision", label: "ID", sortable: true},
        {key: "idSesion", label: "Id Sesión", sortable: true},
        {key: "idClinicaCita", label: "Id Clinica Cita", sortable: true},
        {key: "clinica", label: "Clinica", sortable: true},
        {key: "idEmpleado", label: "Id Empleado NSD", sortable: true},
        {key: "numeroEmpleado", label: "Id Empleado ERP", sortable: true},
        {key: "region", label: "Región", sortable: true},
        {key: "empleado", label: "Empleado", sortable: true},
        {key: "clinicas", label: "Clinicas Empleado", sortable: true},
        {key: "bono", label: "BIP", sortable: true},
        {key: "especialidad", label: "Especialidad", sortable: true},
        {key: "tipoRegimen", label: "Tipo de regimen", sortable: true},
        {key: "concepto", label: "Concepto comisión", sortable: true},

      ],
      fieldsExcel: {
        "ID comisión": "idComision",
        "Id sesión": "idSesion",
        "Id clinica cita": "idClinicaCita",
        "Clinica": "clinica",
        "Id empleado NSD": "idEmpleado",
        "Id empleado ERP": "numeroEmpleado",
        "Región": "region",
        "Empleado": "empleado",
        "Clinicas empleado": "clinicas",
        "BIP": "bono",
        "Especialidad": "especialidad",
        "Tipo de regimen": "tipoRegimen",
        "Concepto": "concepto",
      },
      filtro: {
        fechaInicio: null,
        fechaFin: null,
      },
      palabraClave: null,
      subTotal: 0,
      total: 0,
    }
  },
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerDatos() {
      this.$v.filtro.$touch();
      if (!this.$v.filtro.$invalid) {
        this.loader = true;
        this.datosTabla = [];
        this.paginaActual = 1;

        const envio = {
          fechaInicio: this.$moment(this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD"))
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          fechaFin: this.$moment(this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD"))
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
          horas: this.$horas(),
        };

        this.$http
            .post(this.$api + "comisiones/comisiones/general/bip", envio)
            .then((respuesta) => {
              if (respuesta.data.data) {
                this.subTotal = 0
                this.datosTabla = respuesta.data.data;

                this.datosTabla.map(value => {
                  this.subTotal += value.bono;
                })
              }
            })
            .finally(() => {
              this.loader = false;
            });
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
    filterTable(row, filter) {
      return parseInt(row.idEmpleado) === parseInt(filter)
          || row.empleado.toLowerCase().search(filter.toLowerCase()) !== -1
          || row.clinica.toLowerCase().search(filter.toLowerCase()) !== -1

    }
  }
}
</script>

<style scoped>

</style>
